// Who may add, edit or delete a query library entry.
// organization_id null = universal library (superusers only).
// Organisation entries: superusers, or admins of that organisation.

/** @param {{ role?: string, organizationId?: string|null }} user @param {{ organization_id?: string|null }} template */
export function canManageTemplate(user, template) {
  if (user.role === "superuser") return true;
  if (user.role !== "admin" || !user.organizationId) return false;
  return !!template.organization_id && template.organization_id === user.organizationId;
}

/** @param {{ role?: string, organizationId?: string|null }} user */
export function canAddToLibrary(user) {
  return user.role === "superuser" || (user.role === "admin" && !!user.organizationId);
}
